export default __webpack_public_path__ + "static/media/793.d2186408.gif";